import React, { useEffect, useContext, useState } from 'react'
import AuthUserContext from './User/Session/context'

export default function Authorise(props) {
   const authUser = useContext(AuthUserContext)
   return authUser && authUser.roles && authUser.roles[props.group] && authUser.roles[props.group] == props.role && props.children || null
}
